import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import type { ReactElement } from 'react';

interface ActionHintProps {
  title?: string | null;
  testId?: string;
  /** Disabled controls do not receive hover. The wrapper does, and shows not-allowed. */
  blocked?: boolean;
  children: ReactElement;
}

const HintTarget = styled('span', {
  shouldForwardProp: (prop) => prop !== 'blocked',
})<{ blocked?: boolean }>(({ blocked }) => ({
  display: 'inline-flex',
  maxWidth: '100%',
  verticalAlign: 'middle',
  cursor: blocked ? 'not-allowed' : 'inherit',
  // Disabled buttons and inputs swallow pointer events, so the tooltip never opens.
  '& > *': {
    pointerEvents: 'none',
  },
}));

const ActionHint = ({ title, testId, blocked = false, children }: ActionHintProps) => {
  if (!title) return children;

  return (
    <Tooltip title={title} describeChild placement="top">
      <HintTarget tabIndex={0} data-testid={testId} blocked={blocked}>
        {children}
      </HintTarget>
    </Tooltip>
  );
};

export default ActionHint;
